import * as React from 'react';

var IconCardSectionContext = React.createContext({ cardSize: 'regular' });
var useIconCardSectionContext = function () { return React.useContext(IconCardSectionContext); };

export { IconCardSectionContext, useIconCardSectionContext };
//# sourceMappingURL=IconCardSectionContext.esm.js.map
